import { BannerWrapper } from "./styled.components";

const Banner = (props: any) => {
  return <BannerWrapper>{props.children}</BannerWrapper>;
};

export default Banner;
